import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell, Field, FormError } from "@/components/auth/AuthShell";
import { ApiError } from "@/api/client";
import { api } from "@/api/endpoints";
import { useSession } from "@/store/session";

export function Register() {
  const navigate = useNavigate();
  const setSession = useSession((s) => s.setSession);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr("");
    if (!email.includes("@")) return setErr("Please enter a valid email address.");
    if (password.length < 8) return setErr("Password must be at least 8 characters.");
    if (password !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      const res = await api.auth.register({
        email: email.trim().toLowerCase(),
        password,
      });
      setSession(res);
      navigate("/chat", { replace: true });
    } catch (e) {
      if (e instanceof ApiError) {
        if (e.status === 409 || e.code === "ALREADY_EXISTS") {
          setErr("An account with this email already exists.");
        } else {
          setErr(e.message || "Could not create account.");
        }
      } else {
        setErr("Something went wrong. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell kicker="Create an account" title="Begin an inquiry.">
      <form onSubmit={submit}>
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          placeholder="you@example.com"
          autoComplete="email"
          autoFocus
        />
        <Field
          label="Password"
          type="password"
          value={password}
          onChange={setPassword}
          placeholder="At least 8 characters"
          autoComplete="new-password"
        />
        <Field
          label="Confirm Password"
          type="password"
          value={confirm}
          onChange={setConfirm}
          placeholder="Repeat your password"
          autoComplete="new-password"
        />
        {err && <FormError message={err} />}
        <button
          type="submit"
          className="sa-btn"
          style={{ width: "100%", padding: "12px 18px" }}
          disabled={busy}
        >
          {busy ? "Creating account…" : "Create account"}
        </button>
      </form>
      <hr className="sa-hair" style={{ margin: "28px 0" }} />
      <div
        style={{
          fontFamily: "var(--sa-sans)",
          fontSize: 13,
          color: "var(--sa-muted-fg)",
          textAlign: "center",
        }}
      >
        Already have an account?{" "}
        <Link
          to="/login"
          style={{
            color: "var(--sa-accent)",
            textDecoration: "underline",
            textUnderlineOffset: 3,
          }}
        >
          Sign in
        </Link>
      </div>
    </AuthShell>
  );
}
